import { Avatar, Box } from "@mui/material";
import React from "react";

interface Props {
  url?: string;
  rootStyle?: React.CSSProperties;
  avatarStyle?: React.CSSProperties;
}

export default function CustomAvatar({ url, rootStyle, avatarStyle }: Props) {
  return (
    <Box
      sx={{
        ...rootStyle,
      }}
    >
      <Avatar src={url} variant="rounded" sx={{ ...avatarStyle }} />
    </Box>
  );
}
